import React, { Component, Fragment } from 'react'
import DashboardLayout from '../../components/Admin/DashboardLayout'
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBBtn,
  MDBIcon,
  MDBModal,
  MDBModalHeader,
  MDBModalBody,
  MDBModalDialog,
  MDBModalContent,
  MDBModalTitle,
} from 'mdb-react-ui-kit'
import MDB4Datatable from '../../components/content/MDB4Datatable/MDB4Datatable.component'
import AdminApi from '../../api/admin-api/admin-api'
import { toast } from 'react-toastify'
import moment from 'moment'
import { phoneToView } from './../../shared/formatters/telephone.formatter'

class WebsiteContactRequests extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      confirmModal: false,
      summaryModal: false,
      viewdata: '',
      contactRequests: [],
      pagination: { page: 0, per_page: 10 },
      data: {
        columns: [
          {
            label: 'Name',
            field: 'name',
            sort: 'asc',
            width: 150,
          },
          {
            label: 'Email',
            field: 'email',
            sort: 'asc',
            width: 150,
          },
          {
            label: 'Phone',
            field: 'phone',
            sort: 'asc',
            width: 150,
          },
          {
            label: 'Date',
            field: 'date',
            sort: 'asc',
            width: 150,
          },
          {
            label: 'View',
            field: 'view',
            sort: 'asc',
            width: 150,
          },
          {
            label: 'Delete',
            field: 'delete',
            sort: 'asc',
            width: 270,
          },
        ],
        rows: [],
      },
    } //state
  }
  componentDidMount() {
    this.fetchQuoteContactRequest()
  }

  confirm_DeleteRequest = data => {
    this.confirm_toggle(data)
  }
  confirm_toggle = (data = {}) => {
    this.setState({ confirmModal: !this.state.confirmModal, ...data })
  }

  confirm_ViewRequest = data => {
    this.confirm_summarytoggle(data)
  }

  confirm_summarytoggle = (data = {}) => {
    this.setState({ summaryModal: !this.state.summaryModal, ...data })
  }

  fetchQuoteContactRequest = async () => {
    this.setState({ loading: true })
    AdminApi.getQuoteContactRequest('contact')
      .then(result => {
        if (result && result.data && result.data.data) {
          this.setState({ contactRequests: result.data.data || [], loading: false }, this.setRows)
        }
      })
      .catch(error => {
        this.setState({ loading: false })
        toast.error(error.message, { position: toast.POSITION.TOP_RIGHT })
      })
  }

  setRows = () => {
    const { contactRequests } = this.state
    if (contactRequests && contactRequests.length) {
      const self = this
      let rows = contactRequests.map(row => {
        const { co_fname, co_lname, co_email, co_phone, co_submitted } = row

        function viewRequestSummary() {
          self.confirm_ViewRequest({ viewdata: row })
        }

        function deleteRequest() {
          self.confirm_DeleteRequest({ viewdata: row })
        }

        const viewButton = (
          <div className={'d-flex align-items-center justify-content-center'}>
            <div className={'cursor-pointer d-inline-block'} role={'button'} onClick={viewRequestSummary}>
              <MDBIcon icon='search' size='2x' className='blue-text p-1' />
            </div>
          </div>
        )

        const deleteClick = (
          <div className={'d-flex align-items-center justify-content-center'}>
            <div className={'cursor-pointer d-inline-block'} role={'button'} onClick={deleteRequest}>
              <MDBIcon icon='trash' size='2x' className='red-text p-1' />
            </div>
          </div>
        )

        const submitted_date = (
          <span data-searchvalue={co_submitted ? moment(co_submitted).format('YYYY/MM/DD') : ''}>
            {co_submitted ? moment(co_submitted).format('MM/DD/YYYY') : 'N/A'}
          </span>
        )

        return {
          name: `${co_fname} ${co_lname ? co_lname : ''}`,
          email: co_email ? co_email : 'N/A',
          phone: co_phone ? phoneToView(co_phone) : 'N/A',
          date: submitted_date,
          view: viewButton,
          delete: deleteClick,
        }
      })
      this.setState({
        data: { ...this.state.data, rows: rows },
      })
    }
  }

  _DeleteRequest = async id => {
    this.setState({ deleting: true })

    AdminApi.deleteQuoteContactRequest('contact', id)
      .then(result => {
        this.setState({ deleting: false })
        this.confirm_toggle()
        toast.success('Request successfully deleted', {
          position: toast.POSITION.TOP_RIGHT,
        })
        this.fetchQuoteContactRequest()
      })
      .catch(error => {
        this.setState({ deleting: false })
        toast.error(error.message, { position: toast.POSITION.TOP_RIGHT })
      })
  }

  exportToCSV = () => {
    const { contactRequests } = this.state
    const csvRows = []

    // Header row
    csvRows.push(['Name', 'Email', 'Phone', 'Date', 'Message', 'Type'])

    // Data rows
    contactRequests.forEach(contact => {
      const name = `${contact.co_fname} ${contact.co_lname}`
      const email = contact.co_email
      const phone = contact.co_phone
      const date = new Date(contact.co_submitted).toLocaleDateString()
      const message = contact.co_message.replace(/\n/g, '')
      const type = 'Contact'
      csvRows.push([name, email, phone, date, message, type])
    })

    // Combine rows into CSV format
    const csvData = csvRows.map(row => row.join(',')).join('\n')

    // Create a blob containing the CSV data
    const blob = new Blob([csvData], { type: 'text/csv' })

    // Create a temporary link and click it to trigger the download
    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)
    link.download = 'contact_requests.csv'
    link.click()
  }

  render() {
    toast.configure()
    const { loading, confirmModal, summaryModal, data, viewdata } = this.state

    return (
      <Fragment>
        <DashboardLayout>
          <main className='mainSection'>
            <MDBContainer fluid className='mt-5'>
              {loading ? (
                <h2>Loading...</h2>
              ) : (
                <>
                  <h2>Contact Requests</h2>
                  <MDB4Datatable
                    data={data}
                    sortRows={['date']}
                    responsive
                    striped
                    bordered
                    small
                    className='text-capitalize text-truncate'
                  />

                  <div className='d-flex justify-content-end'>
                    <MDBBtn
                      type='button'
                      className='btn-block w-auto export-csv-button'
                      disabled={this.state.updating}
                      color='info'
                      onClick={this.exportToCSV}
                    >
                      Download CSV
                    </MDBBtn>
                  </div>
                </>
              )}
              <MDBModal open={confirmModal} tabIndex='-1' onClose={this.confirm_toggle}>
                <MDBModalDialog size='sm'>
                  <MDBModalContent>
                    <MDBModalHeader>
                      <MDBModalTitle>Delete Request</MDBModalTitle>
                      <MDBBtn type='button' className='btn-close' color='none' onClick={this.confirm_toggle}></MDBBtn>
                    </MDBModalHeader>
                    <MDBModalBody>
                      <div className='h5'>Are you sure you want to delete this Request?</div>
                      <MDBBtn type='button' color='secondary' size={'sm'} onClick={this.confirm_toggle}>
                        Close
                      </MDBBtn>
                      <MDBBtn
                        type='button'
                        color='danger'
                        size={'sm'}
                        onClick={() => {
                          this._DeleteRequest(this.state.viewdata.id)
                        }}
                      >
                        {this.state.deleting ? 'Deleting...' : 'Delete'}
                      </MDBBtn>
                    </MDBModalBody>
                  </MDBModalContent>
                </MDBModalDialog>
              </MDBModal>

              <MDBModal open={summaryModal} tabIndex='-1' onClose={this.confirm_summarytoggle}>
                <MDBModalDialog>
                  <MDBModalContent>
                    <MDBModalHeader>
                      <MDBModalTitle>Summary</MDBModalTitle>
                      <MDBBtn
                        type='button'
                        className='btn-close'
                        color='none'
                        onClick={this.confirm_summarytoggle}
                      ></MDBBtn>
                    </MDBModalHeader>
                    <MDBModalBody>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: viewdata && viewdata.co_summary ? viewdata.co_summary : 'N/A',
                        }}
                      />
                      <MDBBtn type='button' color='secondary' size={'sm'} onClick={this.confirm_summarytoggle}>
                        Close
                      </MDBBtn>
                    </MDBModalBody>
                  </MDBModalContent>
                </MDBModalDialog>
              </MDBModal>
            </MDBContainer>
          </main>
        </DashboardLayout>
      </Fragment>
    )
  }
}

export default WebsiteContactRequests
